module.exports = __webpack_public_path__ + "static/media/mkanlogo.996bb05d.jpg";